import './DataGridContextMenuItem.2847fc69a59206a2429e015e776fefdc.css';
export default {"menuItem":"_menuItem_npy1h_1","disabled":"_disabled_npy1h_1"};